import * as React from "react";
const IndeterminateXSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "currentColor", width: size || "16", height: size || "16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 7h8v2H4z" }));
IndeterminateXSmall.displayName = "IndeterminateXSmall";
var IndeterminateXSmall_default = IndeterminateXSmall;
export {
  IndeterminateXSmall_default as default
};
